import { render, staticRenderFns } from "./TdxDropdownItem.vue?vue&type=template&id=07ce6444&scoped=true&"
import script from "./TdxDropdownItem.vue?vue&type=script&lang=js&"
export * from "./TdxDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./TdxDropdownItem.vue?vue&type=style&index=0&id=07ce6444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ce6444",
  null
  
)

export default component.exports